// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LzQJ","question":"styles_question__1OeNt","description":"styles_description__FosCS"};